import type { AcademySettlementWithIdentity } from '~/api-spec/__generated__/main'
import type { GroupOrderSettlementInfoResponse } from '~/api-spec/__generated__/pod'
import { parseApiResponse } from '~/schema/apiBoundary'

import {
  type MonthlySettlement,
  MonthlySettlementSchema,
  type SettlementAccount,
  SettlementAccountSchema,
} from './schemas'

const ENTITY = 'PodSettlement'

export const adaptMonthlySettlement = (raw: GroupOrderSettlementInfoResponse): MonthlySettlement =>
  parseApiResponse(MonthlySettlementSchema, raw, ENTITY)

// 생성 타입은 모든 필드를 optional 로 그리지만 서버는 키를 빼지 않고 null 을 싣는다(위 근거). 스키마가 실제 와이어를
// 검증하므로 입력을 unknown 으로 넘긴다.
const asWire = (raw: AcademySettlementWithIdentity | undefined): unknown => raw

export const adaptSettlementAccount = (
  raw: AcademySettlementWithIdentity | undefined,
): SettlementAccount => parseApiResponse(SettlementAccountSchema, asWire(raw), ENTITY)
